module.exports = {
  AGENDA: 'AGENDA',
  ASSIGN: 'ASSIGN',
  CREATE: 'CREATE',
  MANAGE: 'MANAGE',
  READ_ONLY: 'READ_ONLY',
};
